import { memo, useEffect } from "react";
import { DropdownButton } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { createPlacement } from "../utils";
import { StyledCellContainer, StyledCrmDropdownItem, StyledDropdown, StyledDropdownWrapper } from "../styles";
import { usePreDefinedValidation } from "../hooks/usePreDefinedValidation";

import { CRM_CELL_PLACEHOLDER, CRM_EXPORT_DROPDOWN_HEIGHT } from "./constants";
import type { PickListCellPropsType } from "./types";

const PickListCell = ({
    value,
    setValue,
    tableLength,
    index,
    options,
    setting,
    dataType,
    exportName,
}: PickListCellPropsType) => {
    const { placement } = createPlacement(tableLength, index);
    const appendClass = `picklist-dropdown-${exportName}-${index}`;
    const { validate } = usePreDefinedValidation(setting);

    useEffect(() => {
        if (value !== undefined) {
            validate(dataType, value);
        }
    }, []);

    const onClick = ({ id }: { id: string }) => {
        setValue(id);
    };

    const renderDropdownItems = () => {
        const isValueInOptions = value && options && value in options;
        const allOptions = [
            <DropdownButton key="button">{isValueInOptions ? options[value] : value || ""}</DropdownButton>,
        ];

        if (options) {
            const optionsArray = Object.entries(options).map(([key, label]) => (
                <StyledCrmDropdownItem
                    key={key}
                    selected={label === value}
                    id={key}
                    text={label}
                >
                    {label}
                </StyledCrmDropdownItem>
            ));
            allOptions.push(...optionsArray);
        }

        return allOptions;
    };

    const searchFilter = (term: string, { props: { text } }: { props: { text: string } }) => {
        if (text) {
            return text.toLowerCase().includes(term.toLowerCase());
        }
        return false;
    };

    return (
        <StyledCellContainer className={appendClass}>
            <StyledDropdownWrapper>
                <StyledDropdown
                    hasSearch
                    dropdownPopupHeight={CRM_EXPORT_DROPDOWN_HEIGHT}
                    dropdownPopupPlacement={placement}
                    appendTo={`.${appendClass}`}
                    onClick={onClick}
                    searchPlaceHolder={translate(CRM_CELL_PLACEHOLDER)}
                    searchFilter={searchFilter}
                >
                    {renderDropdownItems()}
                </StyledDropdown>
            </StyledDropdownWrapper>
        </StyledCellContainer>
    );
};

export default memo(PickListCell);
